// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"4ca03dd5","850":"d759c14a"}[chunkId] + ".chunk.js";
};